module.exports = __webpack_public_path__ + "img/not_found_image.54c9fed0.svg";